import type { Language } from '@offer-catalog/services/i18n'
import type { ProductOrder } from '@/contexts/products/ProductsContext'
import type { FacetFilters, ViewMode } from '@/types/catalog'

interface ProductFacetsQueryKeyInput {
  season: string
  departmentId: number | undefined
  familiesIds: number[]
  subdepartmentIds: number[] | undefined
  viewMode: ViewMode
  productCode: string | undefined
  filters: FacetFilters
  isNew: boolean
  currentLanguage: Language
  czListSetsKey: readonly (readonly [string, string])[]
}

interface ProductsInfiniteQueryKeyInput {
  universeId: number
  departmentId: number
  subdepartmentIds: number[] | undefined
  isFullDepartment: boolean
  familiesIds: number[]
  viewMode: ViewMode
  productCode: string | undefined
  filters: FacetFilters
  isNew: boolean
  order: ProductOrder
}

export const productQueryKeys = {
  productFacets: ({
    season,
    departmentId,
    familiesIds,
    subdepartmentIds,
    viewMode,
    productCode,
    filters,
    isNew,
    currentLanguage,
    czListSetsKey,
  }: ProductFacetsQueryKeyInput) => ['useProductFacets', season, departmentId, familiesIds, subdepartmentIds, viewMode, productCode, filters, isNew, currentLanguage, czListSetsKey] as const,
  productsInfinite: ({
    universeId,
    departmentId,
    subdepartmentIds,
    isFullDepartment,
    familiesIds,
    viewMode,
    productCode,
    filters,
    isNew,
    order,
  }: ProductsInfiniteQueryKeyInput) => ['useProductsInfinite', universeId, departmentId, subdepartmentIds, isFullDepartment, familiesIds, viewMode, productCode, filters, isNew, order] as const,
  productsHeader: (
    universeId: string,
    departmentId: string,
    familyIds: string[],
    subdepartmentIds: number[] | undefined,
    season: string,
    filters: FacetFilters,
    productCode: string | null,
  ) => ['useProductsHeader', universeId, departmentId, familyIds, subdepartmentIds, season, filters, productCode] as const,
  smModelsInfiniteQuery: (season: string, superModelId: number) => ['useSmModelsInfiniteQuery', season, superModelId] as const,
  colors: (ids: string[] | undefined, currentLanguage: Language) => ['colors', ids, currentLanguage] as const,
  benefitLabels: (ids: string[], currentLanguage: Language) => ['benefitLabels', ids, currentLanguage] as const,
  brands: (id: string | undefined, currentLanguage: Language) => ['brands', id, currentLanguage] as const,
  rawMaterials: (ids: string[], currentLanguage: Language) => ['raw_materials', ids, currentLanguage] as const,
  partOfProducts: (ids: (string | undefined)[] | undefined, currentLanguage: Language) => ['part_of_products', ids, currentLanguage] as const,
  productNatures: (id: string | undefined, currentLanguage: Language) => ['productNatures', id, currentLanguage] as const,
  productImageAvailability: (imageUrl: string | undefined) => ['product-image-availability', imageUrl] as const,
}
